// Context di react per la gestione dei vincoli di cardinalità
import { type VincoloCardinalitaDTO } from '@framework/api-client/api/inquiries/schemas/vincoloCardinalitaDTO.ts';
import { createContext, useContext, useMemo } from 'react';

export interface ICardinalityConstraintContext {
  setConstraints: (
    constraints: VincoloCardinalitaDTO[] | undefined | null,
  ) => void;
  constraints: VincoloCardinalitaDTO[] | undefined | null;
}

export const CardinalityConstraintContext =
  createContext<ICardinalityConstraintContext>({
    constraints: null,
    setConstraints: () => {},
  });

export function useCardinalityConstraintContext(): ICardinalityConstraintContext {
  const context = useContext(CardinalityConstraintContext);
  if (!context) {
    throw new Error(
      'useCardinalityConstraintContext must be used within a CardinalityConstraintProvider',
    );
  }
  return context;
}

/**
 * Contesto per gestire le violazioni dei vincoli di cardinalità.
 * I vincoli violati non ritornano più dall'API di GET ma solo
 * in fase di salvataggio dei moduli (o come errore in fase di invio).
 * Quando riscontriamo una violazione (response del salvataggio)
 * andiamo ad aggiornare il constesto così da poterli visualizzare.
 */
export function CardinalityConstraintContextProvider(
  props: React.PropsWithChildren<
    Omit<ICardinalityConstraintContext, 'getConstraints'>
  >,
) {
  const contextValue: ICardinalityConstraintContext = useMemo(
    () => ({
      constraints: props.constraints,
      setConstraints: props.setConstraints ?? (() => {}),
    }),
    [props.constraints, props.setConstraints],
  );

  return (
    <CardinalityConstraintContext.Provider value={contextValue}>
      {props.children}
    </CardinalityConstraintContext.Provider>
  );
}
